import { useState, MouseEvent } from 'react';

export interface Position {
  top: number;
  left: number;
}

interface UsePositionHook {
  position?: Position;
  handlePosition: (event: MouseEvent<HTMLElement>) => void;
}

const usePosition = (): UsePositionHook => {
  const [position, setPosition] = useState<Position | undefined>();

  const handlePosition = (event: MouseEvent<HTMLElement>) => {
    if (!event.currentTarget) return;

    // 클릭한 DOM의 위치 정보를 추출
    const clickedElement = event.currentTarget;
    const rect = clickedElement.getBoundingClientRect();

    // 위치 정보를 state에 저장
    setPosition({
      top: rect.top,
      left: rect.left,
    });
  };

  return { position, handlePosition };
};

export default usePosition;
